<template>
  <div 
    class="fight-card-menu" 
    @mouseenter="$emit('fightCardMenuMouseEnterEmit')"
    @mouseleave="$emit('fightCardMenuMouseLeaveEmit')" 
    :style="fightCardMenuStyle"
    @click.stop
  >
    <div class="fight-card-menu-inner">
      <div class="create-fight-card card-item" @click.stop="openCardConfig">
        <div class="card-item-text">
          创建名片
        </div>
      </div>
      <div class="sync-fight-card card-item" @click.stop="handleSyncHeyboxFightCard">
        <div class="card-item-text">
          同步小黑盒App绑定游戏
        </div>
        <div class="sync-item" v-if="hasSyncHeyboxFightCard">
          <div class="sync-item-text">
           {{ syncCardState ? '同步中' : '已同步' }}
          </div>
          <div
            v-if="syncCardState === true"
            class="iconfont loading"
          >
            <div
              class="loading-item"
            ></div>
          </div>
          <i v-else class="iconfont icon-toast-success success"></i>
        </div>
      </div>

      <div class="split-wrapper" v-if="list.length > 0">
        <div class="split-inner"></div>
      </div>

      <div v-for="item of list" :key="item.id" class="fight-card-item card-item" @click.stop="sendUserCardMessage(item)">
        <div class="app-icon">
          <ChatImg :src="item.icon" :webp_quality="30" :thumbnail="`64x`" gif_active_type="hover"
            :hover_dom_handler="() => $el" />
        </div>
        <div class="display-text text-ellipse">{{ item.display_text }}</div>
        <div class="app-name">{{ item.app_name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "_lib/EventBus";
import { sendMessage } from "_api/message";
import { mapGetters, mapMutations } from "vuex";
import { IM_MSG_TYPE } from "_lib/constants/IM";
import { upsertCard, getUserCardSetting, syncFightCardsFromHeybox } from "_api/account"
import { CHANNEL_TYPES } from "_lib/constants/channel";

export default {
  data() {
    return {
      syncCardState: undefined
    };
  },
  computed: {
    fightCardMenuStyle() {
      return { 
        bottom: !this.isShow.teamInvite ? '28px' : '60px',
        left: this.isShow.teamIdCard ? '-150px' : '100px'
      }
    },
    hasSyncHeyboxFightCard() {
      return this.syncCardState !== undefined
    },
    ...mapGetters([
      "cur_room_data",
      "channelIMId",
      "user_info",
      'cur_text_channel_data',
      "cur_channel_data",
      'user_card_setting',
      'cur_im_slow_mode_cd',
      'cur_global_team',
    ])
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    /**
     * 表示是从哪个按钮打开的
     * {
     *  teamFight: true, // 开黑邀约
     *  teamInvite: true, // 开黑名片
     *  teamIdCard: true // 全局组队 开黑名片
     * }
     */
    isShow: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    const { left, width } = this.$el.getBoundingClientRect();
    const hiddenPlaWidth = 15
    const menuPlaWidth = 50

    if (left + width > document.body.clientWidth) {
      this.$el.style.left = `${-(width + hiddenPlaWidth + menuPlaWidth)}px`;
    }
  },
  methods: {
    openCardConfig() {
      EventBus.$dynamic("AddGameCard", {
        confirmCb: this.insertGameCard,
        thirdPlatformOptions: this.user_card_setting.third_party_app_platform,
        gamePlatformOptions: this.user_card_setting.game_platform
      })
    },
    insertGameCard(data) {
      if (this._upsetLock) return
      if(data.app_id) {
        const sameGameList = this.user_card_setting.cards.filter(
          item => item.app_id == data.app_id
        )
        if(sameGameList.length >= 5) {
          this.$toast.error("不能添加超过5个相同游戏的名片")
          return
        }
      } else {
        const samePlatformList = this.user_card_setting.cards.filter(
          item => item.type !== "game_app" && item.platform === data.platform
        )
        if(samePlatformList.length >= 5) {
          this.$toast.error("不能添加超过5个相同平台的名片")
          return
        }
      }
      this._upsetLock = true
      upsertCard({}, data).then(async (res) => {
        if(res.data.status === 'ok') {
          const settingCard = await this.getUserCardSetting();
          const newCard = settingCard.cards[settingCard.cards.length - 1]
          this.sendUserCardMessage(newCard)
        }
      }).finally(() => {
        this._upsetLock = false
      })
    },
    async getUserCardSetting () {
      const res = await getUserCardSetting();
      if(res.data.status === 'ok') {
        this.SET_USER_CARD_SETTING(res.data.result.setting || [])
        return res.data.result.setting || []
      }
    },
    sendUserCardMessage(item) {
      if (this.cur_im_slow_mode_cd) return
      EventBus.$dynamic("FightCardConfirmDialog", {
        msgCard: item,
        userInfo: this.user_info,
        confirmCb: () => {
          this.handleConfirmSendUserCardMessage(item)
        }
      })
    },
    getChannelType() {
      let channelType = this.cur_text_channel_data?.channel_type;
      // INFO: channelType 可能为 0
      if (channelType == null || channelType === undefined) {
        channelType = this.cur_channel_data?.channel_type;
      }
      return channelType;
    },
    handleSyncHeyboxFightCard() {
      // 已同步过
      if(this.syncCardState !== undefined) return
      if(this._syncHeyboxFightCardLock) return
      this._syncHeyboxFightCardLock = true
      this.syncCardState = true
      syncFightCardsFromHeybox().then(res => {
        if(res.data.status === 'ok') {
          this.syncCardState = false
          this.$emit('refresh')
        }
      }).finally(() => {
        this._syncHeyboxFightCardLock = false
      })
    },
    handleConfirmSendUserCardMessage(item) {
      if(this.isShow.teamIdCard) {
        if(this.cur_global_team?.team_id) {
          sendMessage({}, {
            msg: item.id,
            msg_type: IM_MSG_TYPE.fight,
            heychat_ack_id: '0',
            reply_id: '',
            room_id: this.cur_global_team?.team_id,
            channel_id: this.cur_global_team?.team_id,
            addition: '{}',
            channel_type: CHANNEL_TYPES.global_team
          })
        }
      } else {
        const channelType = this.getChannelType()
        const roomId = this.cur_room_data?.room_id
        if (roomId) {
          sendMessage({}, {
            msg: item.id,
            msg_type: IM_MSG_TYPE.fight,
            heychat_ack_id: '0',
            reply_id: '',
            room_id: roomId,
            channel_id: this.channelIMId,
            addition: '{}',
            channel_type: channelType
          }).catch((err) => {
            console.log(err)
          })
        }
      }
    },
    ...mapMutations([
      'SET_USER_CARD_SETTING',
    ])
  },
};
</script>

<style lang="scss">
.fight-card-menu {
  width: 290px;

  position: absolute;
  bottom: 28px;
  left: 100px;
  z-index: 999;

  display: flex;
  justify-content: center;

  .fight-card-menu-inner {
    width: 260px;
    max-height: 310px;
    background-color: $d-fl-pp;
    border: 1px solid $d-op-1;
    box-shadow: 0px 2px 13px rgba(0, 0, 0, 0.07);
    border-radius: 8px;
    padding: 8px;
    z-index: 2;
    box-sizing: border-box;
    overflow: auto;

    .create-fight-card,
    .sync-fight-card {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: $d-tx-2;

      &:hover {
        background: $d-bd-fl;
        color: white !important;
      }
    }

    .sync-fight-card {
      .sync-item {
        display: flex;
        align-items: center;
        gap: 6px;
        .sync-item-text {
          flex: 1 0 0;
          color: $d-op-3;
          text-align: right;
          font-size: 12px;
          line-height: 16px;
        }
        .iconfont {
          width: 12px;
          height: 12px;
          font-size: 12px;
          &.loading {
            border: 2px solid $d-tx-4;
            position: relative;
            border-radius: 50%;

            .loading-item {
              border: 2px solid transparent;
              border-left: 2px solid $d-bd-tx;
              border-radius: 50%;
              position: absolute;
              top: -2px;
              left: -2px;
              bottom: -2px;
              right: -2px;
              animation: rotate 1s linear infinite
            }
          }

          &.success {
            color: $d-ss-tx;
          }
        }
      }
    }

    .card-item {
      height: 32px;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;

      display: flex;
      align-items: center;
      padding: 5px 8px;
      border-radius: 5px;
    }

    .split-wrapper {
      width: 100%;
      height: 13px;

      display: flex;
      align-items: center;

      .split-inner {
        width: 100%;
        height: 1px;
        background: $d-op-1;
      }
    }

    .fight-card-item {
      &:hover {
        background: $d-bd-fl;

        .display-text {
          color: white !important;
        }

        .app-name {
          color: white !important;
        }
      }

      .app-icon {
        margin-right: 6px;

        .cpt-chat-img {
          width: 22px;
          height: 22px;
        }
      }

      .display-text {
        font-size: 14px;
        color: $d-tx-2;
        margin-right: 6px;
      }

      .app-name {
        font-size: 12px;
        color: $d-tx-4;
      }
    }
  }
}
</style>
